import { Easing, interpolate, spring } from 'remotion';

const clamp = { extrapolateLeft: 'clamp', extrapolateRight: 'clamp' } as const;
export const ease = Easing.bezier(0.22, 1, 0.36, 1);

export const prog = (frame: number, start: number, dur: number) =>
    interpolate(frame, [start, start + dur], [0, 1], { ...clamp, easing: ease });

export const pop = (frame: number, fps: number, start: number, damping = 14) =>
    spring({ frame: frame - start, fps, config: { damping, mass: 0.7 } });

export const lerp = (t: number, a: number, b: number) => a + (b - a) * t;
